import React, { useContext } from 'react';
import product1 from '../media/babydiaper.png'
import product2 from '../media/pillow.png'
import product3 from '../media/drysheet.jpg'
import product4 from '../media/sleepingbag.png'
import { Link, useNavigate } from 'react-router-dom';
import LogContext from '../context/LogContext';
import { homeScroll } from '../smoothScroll';


function Features() {
    const context=useContext(LogContext);
    const navigate = useNavigate();

  return (
    <section id="feature" className="feature" style={{paddingTop:'0'}}>
      <div className="container">
        <div className="section-header">
          <h2>featured products</h2>
        </div>
        <div className="feature-content" >
          <div className="row">
            <div className="col-md-3 col-sm-3 col-xs-6">
              <div className="single-feature">
                <img src={product1} alt="feature image" onClick={()=> navigate("/products/Baby Diaper")} />
                <div className="single-feature-txt text-center">
                  <p>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <span className="feature-review">(38 review)</span>
                  </p>
                  <h3><Link to={`/products/Baby Diaper`} onClick={()=>{}}>Baby Diaper</Link></h3>
                  <h5>&#8377; 200.00 <span className='old-price'>&#8377; 300.00</span></h5>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-6">
              <div className="single-feature">
                <img src={product2} alt="feature image" onClick={()=> navigate("/products/Kidorise Newborn's Head-Shaping Mustard Pillow")} />
                <div className="single-feature-txt text-center">
                  <p>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <span className="spacial-feature-icon"><i className="fa fa-star"></i></span>
                    <span className="feature-review">(35 review)</span>
                  </p>
                  <h3><Link to="/products/Kidorise Newborn's Head-Shaping Mustard Pillow" >Kidorise Newborn's Head-Shaping Mustard Pillow</Link></h3>
                  <h5>&#8377; 100.00 <span className='old-price'>&#8377; 150.00</span></h5>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-6">
              <div className="single-feature">
                <img src={product3} alt="feature image" onClick={()=> navigate("/products/Baby Waterproof Protector Dry Sheet")} />
                <div className="single-feature-txt text-center">
                  <p>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <span className="spacial-feature-icon"><i className="fa fa-star"></i></span>
                    <span className="feature-review">(36 review)</span>
                  </p>
                  <h3><Link to="/products/Baby Waterproof Protector Dry Sheet">Dry Sheet for new born </Link></h3>
                  <h5>&#8377;  500.00 <span className='old-price'>&#8377;  700.00</span></h5>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-6">
              <div className="single-feature">
                <img src={product4} alt="feature image" onClick={()=> navigate("/products/Cotton Sleeping Bag")} />
                <div className="single-feature-txt text-center">
                  <p>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <span className="spacial-feature-icon"><i className="fa fa-star"></i></span>
                    <span className="feature-review">(24 review)</span>
                  </p>
                  <h3><Link to="/products/Baby Cotton Sleeping Bag">Cotton Sleeping Bag</Link></h3>
                  <h5>&#8377;  350.00 <span className='old-price'>&#8377;  450.00</span></h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
